(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;

  /* Per-package icons — ACTUAL Figma SVG paths downloaded from design assets */
  var PACKAGE_ICONS = {
    'clear': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    'blue-light': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="translate(10,13)"><path d="M6.22 0.55H33.9C35.19 0.55 36.23 1.59 36.23 2.88V22.26H3.89V2.88C3.89 1.59 4.93 0.55 6.22 0.55Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M39.58 20.16V22.27C39.58 23.28 38.75 24.1 37.75 24.1H2.38C1.37 24.1 0.55 23.28 0.55 22.27V20.16H39.58Z" fill="white" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></g><g transform="translate(35,10)"><path d="M13.39 0.55H2.18C1.28 0.55 0.55 1.28 0.55 2.18V23.81C0.55 24.71 1.28 25.44 2.18 25.44H13.39C14.29 25.44 15.02 24.71 15.02 23.81V2.18C15.02 1.28 14.29 0.55 13.39 0.55Z" fill="white" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.63 0.61H10.93V1.04C10.93 1.92 10.22 2.64 9.33 2.64H6.22C5.34 2.64 4.62 1.93 4.62 1.04V0.61H4.63Z" fill="white" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></g></svg>',
    'photochromic': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><g transform="translate(5,8)"><circle cx="16" cy="24" r="6.24" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="16" y1="15.5" x2="16" y2="12" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="16" y1="36" x2="16" y2="32.5" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="7.5" y1="24" x2="4" y2="24" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="28" y1="24" x2="24.5" y2="24" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="10" y1="18" x2="7.5" y2="15.5" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="24.5" y1="32.5" x2="22" y2="30" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="10" y1="30" x2="7.5" y2="32.5" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/><line x1="24.5" y1="15.5" x2="22" y2="18" stroke="currentColor" stroke-width="1.1" stroke-miterlimit="10" stroke-linecap="round"/></g><g transform="translate(33,12)"><path d="M13.84 18.76C12.69 19.28 11.4 19.56 10.05 19.56C4.81 19.56 0.55 15.3 0.55 10.05C0.55 4.8 4.81 0.55 10.05 0.55C11.42 0.55 12.7 0.83 13.87 1.35C10.13 2.47 7.4 5.94 7.4 10.05C7.4 14.16 10.12 17.63 13.84 18.77V18.76Z" fill="white" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></g></svg>',
    'non-polarized': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="0.06"/></svg>',
    'polarized': '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M51.91 28.15C51.17 34.11 47.34 39.34 41.77 41.59C40.44 42.13 37.09 42.49 35.88 42.49H24.32C20.61 42.37 17.8 41.62 15.1 39.78C12.87 38.26 11.04 36.39 9.7 34.07C7.94 31.04 7 27.57 7 23.97C7 20.07 10.74 16.93 15.3 17L44.1 17.39C51.59 17.13 52.58 22.86 51.93 28.16L51.91 28.15Z" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" fill="currentColor" fill-opacity="0.06"/><line x1="14" y1="25" x2="46" y2="25" stroke="currentColor" stroke-width="0.7" opacity="0.35"/><line x1="12" y1="30" x2="48" y2="30" stroke="currentColor" stroke-width="0.7" opacity="0.35"/><line x1="14" y1="35" x2="46" y2="35" stroke="currentColor" stroke-width="0.7" opacity="0.35"/></svg>'
  };

  var PACKAGE_ORDER = {
    'clear': 1,
    'blue-light': 2,
    'photochromic': 3,
    'non-polarized': 4,
    'polarized': 5
  };

  var PACKAGE_INFO_CONTENT = {
    'blue-light': '<strong>Blue Light Filtering Lenses</strong><br>Filters blue light from phones and computers to help reduce fatigue during long screen sessions.',
    'photochromic': '<strong>Light-Adaptive Lenses</strong><br>Photochromic lenses that automatically adjust to changing light. They darken outdoors and return to clear indoors.'
  };

  // Hide packages with no lens types so users never land on Step 4 with an empty list.
  function packageHasVisibleLensTypes(config, frameType, rxType, packageKey) {
    if (!config || typeof config.getLensTypes !== 'function') return true;

    var lensTypes = config.getLensTypes({
      frameType: frameType,
      prescriptionType: rxType,
      lensPackageKey: packageKey
    }) || [];

    if (rxType === 'reading' && frameType === 'clear') {
      lensTypes = lensTypes.filter(function (t) { return t.lensTypeKey !== 'premium-ar'; });
    }

    return lensTypes.length > 0;
  }

  var advanceTimer = null;

  function getPackageInfoContent(trigger) {
    var key = trigger.getAttribute('data-info-key');
    var customContent = trigger.getAttribute('data-info-content') || '';
    var i18n = window.WmpI18n || {};
    var info = i18n.info || {};
    var contentKey = key === 'blue-light' ? 'blue_light' : key;
    var helperContent = PACKAGE_INFO_CONTENT[key] || '';

    return helperContent || customContent || info[contentKey] || '';
  }

  function showPackageInfo(trigger) {
    if (!window.WmpInfoBubble || !trigger) return;
    WmpInfoBubble.show(trigger, {
      content: getPackageInfoContent(trigger),
      toggle: false
    });
  }

  /* Vision Club member price, display only (rule lives in wmp-app.js). */
  function memberPriceCents(item, priceCents) {
    return window.WmpVisionClubLensPrice ? window.WmpVisionClubLensPrice.memberCents(item, priceCents) : 0;
  }

  /* INCLUDED / FREE label in place of the price (rule lives in wmp-app.js). */
  function lensPriceLabel(item, priceCents) {
    return window.WmpLensPriceLabel ? window.WmpLensPriceLabel.get(item, priceCents) : '';
  }

  function getPackagePriceLabel(priceCents, comparePriceCents, memberCents, label) {
    if (label) return 'Price ' + label + '.';
    var price = store.formatPrice(priceCents);
    if (memberCents) {
      return 'Member price ' + store.formatPrice(memberCents) + ', applied at checkout. Regular price ' + price + '.';
    }
    if (comparePriceCents && comparePriceCents > priceCents) {
      return 'Sale price ' + price + '. Original price ' + store.formatPrice(comparePriceCents) + '.';
    }
    return 'Price ' + price + '.';
  }

  function renderMemberPrice(priceWrap, priceCents, memberCents) {
    var cfg = window.VisionClubConfig || {};
    var label = (cfg.copy && cfg.copy.lensMemberLabel) || '';
    appendSrOnly(priceWrap, getPackagePriceLabel(priceCents, 0, memberCents) + ' ');

    var memberSpan = document.createElement('span');
    memberSpan.className = 'wmp-card__price--member';
    memberSpan.setAttribute('aria-hidden', 'true');
    memberSpan.textContent = store.formatPrice(memberCents);
    priceWrap.appendChild(memberSpan);

    priceWrap.appendChild(document.createTextNode(' '));

    var origSpan = document.createElement('span');
    origSpan.className = 'wmp-card__price-original';
    origSpan.setAttribute('aria-hidden', 'true');
    origSpan.textContent = store.formatPrice(priceCents);
    priceWrap.appendChild(origSpan);

    if (label) {
      var labelEl = document.createElement('span');
      labelEl.className = 'wmp-card__member-label';
      labelEl.setAttribute('aria-hidden', 'true');
      labelEl.textContent = label;
      priceWrap.appendChild(labelEl);
    }
  }

  function appendSrOnly(parent, text) {
    var span = document.createElement('span');
    span.className = 'wmp-sr-only';
    span.textContent = text;
    parent.appendChild(span);
  }

  function renderPackagePrice(priceWrap, priceCents, comparePriceCents, memberCents, label) {
    priceWrap.innerHTML = '';

    // The label wins over sale and member prices
    if (label) {
      var labelEl = document.createElement('span');
      labelEl.className = 'wmp-lens-price-label';
      labelEl.textContent = label;
      priceWrap.appendChild(labelEl);
    } else if (memberCents) {
      renderMemberPrice(priceWrap, priceCents, memberCents);
    } else if (comparePriceCents && comparePriceCents > priceCents) {
      appendSrOnly(priceWrap, getPackagePriceLabel(priceCents, comparePriceCents) + ' ');

      var saleSpan = document.createElement('span');
      saleSpan.className = 'wmp-card__price--sale';
      saleSpan.setAttribute('aria-hidden', 'true');
      saleSpan.textContent = store.formatPrice(priceCents);
      priceWrap.appendChild(saleSpan);

      priceWrap.appendChild(document.createTextNode(' '));

      var origSpan = document.createElement('s');
      origSpan.className = 'wmp-card__price-original';
      origSpan.setAttribute('aria-hidden', 'true');
      origSpan.textContent = store.formatPrice(comparePriceCents);
      priceWrap.appendChild(origSpan);
    } else {
      priceWrap.textContent = store.formatPrice(priceCents);
    }
  }

  function toA11ySentence(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    return /[.!?]$/.test(text) ? text : text + '.';
  }

  function buildPackageCardLabel(pkg, displayName) {
    var parts = [displayName];
    if (pkg.subtitle) parts.push(pkg.subtitle);
    if (pkg.note) parts.push('Note: ' + pkg.note);
    parts.push(getPackagePriceLabel(pkg.priceCents, pkg.comparePriceCents, memberPriceCents(pkg, pkg.priceCents), lensPriceLabel(pkg, pkg.priceCents)));
    return parts.map(toA11ySentence).filter(Boolean).join(' ');
  }

  function setCardSelected(card, selected) {
    var selectControl = card.querySelector('.wmp-card__select-control');
    card.classList.toggle('wmp-card--selected', selected);
    if (selectControl) {
      selectControl.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
  }

  function render(container) {
    var frameType = store.get('frameType') || 'clear';
    var rxType = store.get('prescriptionType') || 'single-vision';
    var currentPkg = store.get('lensPackage');

    var root = document.getElementById('wmp-prescription-flow');
    var questionIconUrl = root ? root.getAttribute('data-question-icon') : '';
    var nonPolarUrl = root ? root.getAttribute('data-non-polarized-icon') : '';
    var polarUrl = root ? root.getAttribute('data-polarized-icon') : '';
    var infoIconHtml = questionIconUrl
      ? '<img src="' + questionIconUrl + '" alt="" aria-hidden="true" width="16" height="16" loading="eager">'
      : '?';

    var config = window.WmpProductsConfig;
    var packages = config ? config.getLensPackages({ frameType: frameType, prescriptionType: rxType }) : [];

    // Reading flow must never show Photochromic in Step 3 even if misconfigured
    // in admin. Keep this hard guard in UI to enforce the spec.
    if (rxType === 'reading') {
      packages = packages.filter(function (p) { return p.packageKey !== 'photochromic'; });
    }

    packages = packages.filter(function (p) {
      return packageHasVisibleLensTypes(config, frameType, rxType, p.packageKey);
    });

    packages.sort(function (a, b) {
      var ao = PACKAGE_ORDER[a.packageKey] || 999;
      var bo = PACKAGE_ORDER[b.packageKey] || 999;
      if (ao !== bo) return ao - bo;
      return (a.title || a.packageKey || '').localeCompare(b.title || b.packageKey || '');
    });

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = store.getStepHeading('lens-package');
    container.appendChild(heading);

    if (!packages.length) {
      var empty = document.createElement('p');
      empty.className = 'wmp-b1';
      empty.style.cssText = 'text-align:center;color:#999;padding:40px 20px;';
      empty.textContent = 'No lens packages available for this selection.';
      container.appendChild(empty);
      return;
    }

    // Card list
    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    for (var i = 0; i < packages.length; i++) {
      var pkg = packages[i];
      var displayName = (pkg.title || pkg.packageKey || '').toString().toUpperCase();

      var card = document.createElement('div');
      card.className = 'wmp-card wmp-card--separate-controls';
      card.setAttribute('data-value', pkg.packageKey);
      card.setAttribute('data-price', String(pkg.priceCents));
      card.setAttribute('data-variant-id', String(pkg.variantId || ''));

      var selectControl = document.createElement('button');
      selectControl.className = 'wmp-card__select-control';
      selectControl.type = 'button';
      selectControl.setAttribute('aria-label', buildPackageCardLabel(pkg, displayName));
      selectControl.setAttribute('aria-pressed', currentPkg === pkg.packageKey ? 'true' : 'false');
      selectControl.addEventListener('click', onCardClick);
      card.appendChild(selectControl);

      if (currentPkg === pkg.packageKey) card.classList.add('wmp-card--selected');

      // Icon (per-package)
      var iconEl = document.createElement('span');
      iconEl.className = 'wmp-card__icon';
      iconEl.setAttribute('aria-hidden', 'true');
      var iconHtml = PACKAGE_ICONS[pkg.packageKey] || PACKAGE_ICONS['clear'];
      if (pkg.packageKey === 'non-polarized' && nonPolarUrl) {
        iconHtml = '<img src="' + nonPolarUrl + '" alt="" width="60" height="60" loading="eager">';
      } else if (pkg.packageKey === 'polarized' && polarUrl) {
        iconHtml = '<img src="' + polarUrl + '" alt="" width="60" height="60" loading="eager">';
      }
      iconEl.innerHTML = iconHtml;
      card.appendChild(iconEl);

      // Content
      var content = document.createElement('div');
      content.className = 'wmp-card__content';

      // Title row with optional info icon
      var titleRow = document.createElement('div');
      titleRow.style.cssText = 'display:flex;align-items:center;gap:6px;flex-wrap:wrap;';

      var title = document.createElement('span');
      title.className = 'wmp-card__title';
      title.style.marginBottom = '0';
      title.textContent = displayName;
      titleRow.appendChild(title);

      if (pkg.hasInfo) {
        var infoBtn = document.createElement('button');
        infoBtn.className = 'wmp-card__info';
        infoBtn.type = 'button';
        infoBtn.innerHTML = infoIconHtml;
        infoBtn.setAttribute('aria-label', 'More info about ' + displayName);
        infoBtn.setAttribute('aria-expanded', 'false');
        infoBtn.setAttribute('data-info-key', pkg.packageKey);
        infoBtn.setAttribute('data-info-content', pkg.infoContent || '');
        infoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          showPackageInfo(e.currentTarget);
        });
        infoBtn.addEventListener('mouseenter', function (e) {
          showPackageInfo(e.currentTarget);
        });
        infoBtn.addEventListener('focus', function (e) {
          showPackageInfo(e.currentTarget);
        });
        infoBtn.addEventListener('mouseleave', function (e) {
          if (document.activeElement !== e.currentTarget) WmpInfoBubble.hide();
        });
        infoBtn.addEventListener('blur', function () {
          WmpInfoBubble.hide();
        });
        titleRow.appendChild(infoBtn);
      }

      content.appendChild(titleRow);

      if (pkg.subtitle) {
        var desc = document.createElement('span');
        desc.className = 'wmp-card__description';
        desc.style.marginTop = '10px';
        desc.style.display = 'block';
        desc.textContent = pkg.subtitle;
        content.appendChild(desc);
      }

      if (pkg.note) {
        var note = document.createElement('span');
        note.className = 'wmp-card__description';
        note.style.cssText = 'display:block;margin-top:6px;font-size:12px;line-height:16px;';
        note.textContent = '*' + pkg.note;
        content.appendChild(note);
      }

      card.appendChild(content);

      // Price
      var priceWrap = document.createElement('div');
      priceWrap.className = 'wmp-card__price';
      renderPackagePrice(priceWrap, pkg.priceCents, pkg.comparePriceCents, memberPriceCents(pkg, pkg.priceCents), lensPriceLabel(pkg, pkg.priceCents));
      card.appendChild(priceWrap);

      list.appendChild(card);
    }

    container.appendChild(list);
  }

  function onCardClick(e) {
    var card = e.currentTarget.closest ? e.currentTarget.closest('.wmp-card') : e.currentTarget.parentNode;
    if (!card) return;
    var value = card.getAttribute('data-value');
    var price = parseInt(card.getAttribute('data-price'), 10);
    var variantId = card.getAttribute('data-variant-id') || '';

    // Update visual selection
    var cards = card.parentNode.querySelectorAll('.wmp-card');
    for (var i = 0; i < cards.length; i++) {
      setCardSelected(cards[i], false);
    }
    setCardSelected(card, true);

    // Update store. Persist the resolved variant ID from the clicked card so the
    // Review step adds the exact variant the user picked instead of re-matching
    // config keys at submit time (which silently dropped mismatched line items).
    store.set('lensPackage', value);
    store.set('lensPackageVariantId', variantId);

    // Update pricing — store package price separately. Changing the package
    // resets the dependent lens-type charge; prism (from Step 2) is preserved.
    var pricing = store.get('pricing');
    pricing.lensPackage = price;
    pricing.lensType = 0; // reset lens type when package changes
    store.set('pricing', pricing);
    store.recalcLenses();

    // Auto-advance
    if (advanceTimer) clearTimeout(advanceTimer);
    advanceTimer = setTimeout(function () {
      router.advance();
    }, 200);
  }

  function destroy() {
    if (advanceTimer) {
      clearTimeout(advanceTimer);
      advanceTimer = null;
    }
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['lens-package'] = {
    render: render,
    destroy: destroy
  };
})();
